import { Heart, Check } from "lucide-react";
import { DECORACOES, brl } from "../data";
import { Reveal } from "./Reveal";

export default function Decoracao({ selected, onSelect }) {
    return (
        <section id="decoracao" data-testid="decoracao-section" className="py-24 md:py-32 bg-emerald-950 text-stone-100 relative grain">
            <div className="max-w-7xl mx-auto px-4 md:px-8">
                <div className="grid lg:grid-cols-12 gap-12 items-start">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <p className="text-xs font-bold uppercase tracking-[0.3em] text-emerald-300 mb-4">Toque especial</p>
                            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
                                Decoração romântica
                            </h2>
                            <p className="mt-5 text-stone-300 text-base sm:text-lg leading-relaxed">
                                Transforme a estadia em uma surpresa inesquecível. Escolha uma das opções e nós preparamos tudo antes da sua chegada.
                            </p>
                            <div className="mt-8 overflow-hidden border border-emerald-800">
                                <img
                                    src="/images/decoracao.jpg"
                                    alt="Opções de decoração romântica"
                                    className="w-full object-cover hover:scale-[1.02] transition-transform duration-700"
                                    data-testid="decoracao-image"
                                />
                            </div>
                        </Reveal>
                    </div>

                    <div className="lg:col-span-7 space-y-5">
                        {DECORACOES.filter((d) => d.id !== "nenhuma").map((d, i) => (
                            <Reveal key={d.id} delay={i * 0.08}>
                                <button
                                    data-testid={`decoracao-${d.id}-card`}
                                    onClick={() => onSelect(selected === d.id ? "nenhuma" : d.id)}
                                    className={`w-full text-left p-6 md:p-8 border transition-all duration-300 group ${
                                        selected === d.id
                                            ? "border-emerald-300 bg-emerald-900"
                                            : "border-emerald-800/70 bg-emerald-950 hover:border-emerald-600"
                                    }`}
                                >
                                    <div className="flex items-start justify-between gap-4">
                                        <div>
                                            <p className="text-xs font-bold uppercase tracking-[0.25em] text-emerald-300">
                                                Opção {i + 1}
                                            </p>
                                            <h3 className="mt-1 text-xl md:text-2xl font-bold tracking-tight flex items-center gap-2">
                                                {d.nome}
                                                <Heart size={18} className={selected === d.id ? "text-rose-300 fill-rose-300" : "text-emerald-400"} />
                                            </h3>
                                        </div>
                                        <div className="text-right shrink-0">
                                            <p className="text-2xl font-black tracking-tight">{brl(d.valor)}</p>
                                            <p className="text-xs text-stone-400 uppercase tracking-widest">por estadia</p>
                                        </div>
                                    </div>
                                    <ul className="mt-5 grid sm:grid-cols-2 gap-x-6 gap-y-2">
                                        {d.itens.map((item) => (
                                            <li key={item} className="flex items-start gap-2 text-sm text-stone-300">
                                                <Check size={14} className="mt-0.5 text-emerald-400 shrink-0" />
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                    <p className="mt-4 text-xs uppercase tracking-widest text-stone-400">{d.ideal}</p>
                                    <p className={`mt-4 text-xs font-bold uppercase tracking-widest transition-colors ${
                                        selected === d.id ? "text-emerald-200" : "text-stone-400 group-hover:text-stone-200"
                                    }`}>
                                        {selected === d.id ? "Selecionada — ver no resumo da reserva" : "Toque para adicionar à reserva"}
                                    </p>
                                </button>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
